var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.42 22.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f363f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.52,390.94a2.66,2.66,0,0,0,0-5.31,2.69,2.69,0,0,0-1.53.48l0,0v0a4.51,4.51,0,0,1,.16.68l0,.12.08-.08a1.89,1.89,0,1,1-.34,2.35l-.06-.1-.05.1a4.4,4.4,0,0,1-.34.61l0,0,0,0A2.64,2.64,0,0,0,246.52,390.94Z",
    transform: "translate(-231.96 -384.51)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.71,392h-2.16l.08.11a4.83,4.83,0,0,1,.42.62v0h1.65a1.92,1.92,0,0,1,1.91,1.91v4.22a.45.45,0,0,1-.45.45h-1.06v5a.44.44,0,0,1-.44.44h-2.3a.45.45,0,0,1-.41-.27l-.12-.28v1.19l0,0a1.16,1.16,0,0,0,.49.1h2.3a1.2,1.2,0,0,0,1.2-1.2v-4.23h.3a1.21,1.21,0,0,0,1.21-1.21v-4.22A2.68,2.68,0,0,0,247.71,392Z",
    transform: "translate(-231.96 -384.51)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.83,391a2.63,2.63,0,0,0,1.89-.8l0,0,0,0a3.62,3.62,0,0,1-.36-.54l-.05-.07-.05.06a1.89,1.89,0,1,1-1.43-3.13,1.83,1.83,0,0,1,.95.27l.08.05v-.09a4.23,4.23,0,0,1,.18-.62l0-.05,0,0a2.6,2.6,0,0,0-1.19-.28,2.66,2.66,0,1,0,0,5.31Z",
    transform: "translate(-231.96 -384.51)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237,404.8h-2.34a.45.45,0,0,1-.45-.45v-5h-1.06a.45.45,0,0,1-.45-.44v-4.22a1.91,1.91,0,0,1,1.91-1.91h1.26v0a4.25,4.25,0,0,1,.41-.63l.08-.1h-1.76a2.68,2.68,0,0,0-2.67,2.67v4.22a1.21,1.21,0,0,0,1.21,1.2h.3v4.23a1.21,1.21,0,0,0,1.21,1.21h2.45v-.77H237Z",
    transform: "translate(-231.96 -384.51)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241,390.45a3,3,0,1,0-3-3A3,3,0,0,0,241,390.45Zm0-5.16a2.19,2.19,0,1,1-2.2,2.19A2.2,2.2,0,0,1,241,385.29Z",
    transform: "translate(-231.96 -384.51)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.32,399.49v-4.78a3,3,0,0,0-3-3h-2.71a3,3,0,0,0-3,3v4.78a1.33,1.33,0,0,0,1.33,1.33h.38v4.84a1.32,1.32,0,0,0,1.32,1.32h2.61a1.32,1.32,0,0,0,1.32-1.32v-4.84H244A1.33,1.33,0,0,0,245.32,399.49Zm-.77,0a.56.56,0,0,1-.55.55h-1.16v5.62a.55.55,0,0,1-.55.54h-2.61a.56.56,0,0,1-.55-.54V400H238a.55.55,0,0,1-.55-.55v-4.78a2.21,2.21,0,0,1,2.2-2.21h2.71a2.2,2.2,0,0,1,2.2,2.21v4.78Z",
    transform: "translate(-231.96 -384.51)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulation);
export default __webpack_public_path__ + "static/media/population.af2dba325c9d37ff4305e2eb7a96e223.svg";
export { ForwardRef as ReactComponent };